import { Extent } from 'ol/extent';
import { instance } from './api';

export interface MapSettings {
  extent: Extent;
  projection: string;
}

type Service = 'WMS' | 'WMTS';

export interface AlternativeTitle {
  name: string;
  alternative: string;
}

export interface Layer {
  service: Service;
  title: string;
  id: string;
  layers: string[];
  alternativeTitles: AlternativeTitle[];
  baseLayer: boolean;
  groupLayer?: boolean;
  proxy?: boolean;
  visible?: boolean;
  endpoint: string;
  username?: string;
  password?: string;
  options: any;
}

export async function getMapSettings() {
  const { data } = await instance.get<MapSettings>('mapSettings');
  return data;
}

export async function getLayers() {
  const { data } = await instance.get<Layer[]>('mapSettings/layers');
  return data;
}

export async function updateMapSettings(mapSettings: MapSettings) {
  const { data } = await instance.put<MapSettings>('mapSettings', mapSettings);
  return data;
}

export async function updateLayers(layers: Layer[]) {
  const { data } = await instance.put<string>('mapSettings/layers', layers);
  return data;
}
